/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useState, useEffect } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../../tableIcons";
import {
  Tooltip,
  IconButton,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core";
import {
  Edit,
  Delete,
  Add,
  Refresh,
  AddCircleOutline,
} from "@material-ui/icons";
import { format } from "date-fns";
import SnackBar from "../../Snackbar/index";
import SecureWrapper from "../../Security/SecureWrapper";

const useStyles = makeStyles(() => ({
  button: {
    width: "80px",
    background: "#127DFC",
    textTransform: "none",
    color: "#FFFFFF",
    float: "right",
    margin: "10px",
    boxShadow: "0px 3px 6px #0000001A",
    border: "none",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: "#0069d9",
      borderColor: "#0062cc",
      boxShadow: "none",
    },
  },
}));

const GroupsTable = (props) => {
  const classes = useStyles();
  const {
    data,
    toggle,
    setToggle,
    setSelectedData,
    isNew,
    setIsNew,
    deleted,
    setdeleted,
    isCreate,
    newdata,
    setisCreate,
  } = props;
  console.log("grttt....", data?.result);
  const [group, setGroup] = useState(null);
  const [open, setopen] = useState(false);
  const [isdeleted, setisdeleted] = useState(false);

  const handleNewGroup = () => {
    // if (group === null) {
    //   console.log("new clicked");
    setIsNew(true);
    setGroup(null);
    setToggle(false);
    // } else {
    //   setIsNew(false);
    // }
  };

  const handleRowSelected = (rowData) => {
    // console.log("rowData", rowData);
    if (group === rowData?.tableData.id) {
      setToggle(!toggle);
      setGroup(null);
    } else {
      setToggle(true);
      setGroup(rowData?.tableData.id);
    }
    setSelectedData(rowData);
    setIsNew(false);
  };
  useEffect(() => {
    data?.result?.map((row) => {
      if (row.tableData.id === group) {
        setSelectedData(row);
        console.log("uptate data row", row);
      }
      if (isCreate && row.name === newdata) {
        setSelectedData(row);
        setGroup(row.tableData.id);
        setToggle(true);
        setisCreate(false);
      }
    });
  }, [data]);
  useEffect(() => {
    if (deleted === true) {
      setToggle(!toggle);
      setGroup(null);
      setdeleted(false);
      setisdeleted(true);
    }
    if (isCreate) {
      setopen(true);
    }
  });
  console.log("selectedgroup", group);
  const onClose = () => {
    setopen(false);
  };
  const onClosedeleted = () => {
    setisdeleted(false);
  };
  return (
    <div style={{ maxWidth: "100%", display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h6 style={{ paddingLeft: "10px" }}>All Groups</h6>
        <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/group",
                        method : "POST",
                        operands : []
                      }}
          >
          <Button
            className={classes.button}
            startIcon={<AddCircleOutline />}
            style={{ visibility: isNew ? "hidden" : "visible" }}
            onClick={handleNewGroup}
          >
            New
          </Button>
        </SecureWrapper>
      </div>
      <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/group",
                        method : "GET",
                        operands : []
                      }}
                      shouldRenderErrorMessage = {true}
                      errorMessage = "User does not have sufficient privileges"
                      textVariant = "subtitle2"
        >
      <MaterialTable
        data={data?.result}
        icons={table_icons}
        columns={[
          {
            title: "Group Name",
            field: "name",
            searchable: true,
            sorting: true,
            cellStyle: {
              //   width: "20rem",
              //   textAlign: "center",
            },
            render: (rowData) => {
              return (
                <div
                  style={{
                    color: group === rowData.tableData.id ? "#FFF" : "#222222",
                    fontWeight: "bold",
                    fontSize: "13px",
                  }}
                >
                  {rowData?.name || "-"}
                </div>
              );
            },
          },
          {
            title: "Created On",
            field: "created_date",
            searchable: true,
            sorting: true,
            type: "datetime",
            cellStyle: {
              //   width: "15rem",
              color: "#707071",
              fontWeight: "bold",
              // textAlign: "center",
            },
            render: (rowData) => {
              return (
                <div
                  style={{
                    color: group === rowData.tableData.id ? "#FFF" : "#707071",
                  }}
                >
                  {format(new Date(rowData?.created_date), "dd MMM yyyy")}
                </div>
              );
            },
          },
          {
            title: "Users",
            field: "has_users",
            sorting: true,
            cellStyle: {
              //   width: "5rem",
              color: "#222222",
              fontWeight: "bold",
              // textAlign: "center",
            },
            render: (rowData) => {
              return (
                <div
                  style={{
                    color: group === rowData.tableData.id ? "#FFF" : "#707071",
                  }}
                >
                  {rowData?.has_users?.length}
                </div>
              );
            },
          },
          {
            title: "Roles",
            field: "group_roles",
            sorting: true,
            cellStyle: {
              //   width: "5rem",
              color: "#222222",
              fontWeight: "bold",
              // textAlign: "center",
            },
            render: (rowData) => {
              return (
                <div
                  style={{
                    color: group === rowData.tableData.id ? "#FFF" : "#707071",
                  }}
                >
                  {rowData?.group_roles?.length}
                </div>
              );
            },
          },
          // {
          //   title: "",
          //   render: (rowData) => {
          //     return renderEventGroupActions();
          //   },
          //   cellStyle: {
          //     width: "5rem",
          //   },
          // },
        ]}
        components={{
          Toolbar: (props) => (
            <div style={{ background: "#F8FCFF" }}>
              <MTableToolbar {...props} />
            </div>
          ),
        }}
        options={{
          // search: false,
          // toolbar: false,
          showTitle: false,
          paging: true,
          actionsColumnIndex: 5,
          actionsCellStyle: {
            // background: "grey",
          },
          minBodyHeight: "67.5vh",
          maxBodyHeight: "70vh",
          //   pageSizeOptions: [10, 20, 30],
          pageSize: 10,
          headerStyle: {
            background: "#F8FCFF",
            color: "#707071",
            fontSize: "1rem",
            fontWeight: "bold",
            paddingBottom: "0px",
          },
          rowStyle: (rowData) => ({
            backgroundColor:
              group === rowData.tableData.id ? "#70BAFA" : "#FFF",
          }),
        }}
        onRowClick={(event, rowData) => {
          handleRowSelected(rowData);
        }}
      />
      </SecureWrapper>
      {open && (
        <SnackBar
          openDialog={open}
          message={"Group has been created successfully"}
          onclose={onClose}
          severity={"success"}
        />
      )}
      {isdeleted && (
        <SnackBar
          openDialog={isdeleted}
          message={"Group has been deleted successfully"}
          onclose={onClosedeleted}
          severity={"success"}
        />
      )}
    </div>
  );
};

export default GroupsTable;
